import z from "zod";

const planetscaleErrorTypeValues = [
  "DELETE_MAIN_BRANCH_ATTEMPT",
  "BRANCH_DELETION_FAILED",
  "STALE_BRANCH_CLEANUP_CIRCUIT_BREAKER",
  "PLANET_SCALE_CLEANUP_TOKEN_MISSING",
] as const;

const planetscaleErrorTypeSchema = z.enum(planetscaleErrorTypeValues);
const PlanetscaleErrorType = planetscaleErrorTypeSchema.enum;
type PlanetscaleErrorType = z.infer<typeof planetscaleErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type PlanetscaleErrors =
  | {
      errorType: typeof PlanetscaleErrorType.DELETE_MAIN_BRANCH_ATTEMPT;
      data: {
        branchName: string;
      };
    }
  | {
      errorType: typeof PlanetscaleErrorType.BRANCH_DELETION_FAILED;
      data: {
        branchName: string;
        status: number;
      };
    }
  | {
      errorType: typeof PlanetscaleErrorType.STALE_BRANCH_CLEANUP_CIRCUIT_BREAKER;
      data: {
        toDeleteCount: number;
        max: number;
      };
    }
  | {
      errorType: typeof PlanetscaleErrorType.PLANET_SCALE_CLEANUP_TOKEN_MISSING;
      data: Record<string, never>;
    };

export const planetscaleErrorDetails: Record<PlanetscaleErrorType, ErrorDetails> = {
  [PlanetscaleErrorType.DELETE_MAIN_BRANCH_ATTEMPT]: {
    sentryDescription: "Attempted to delete a main PlanetScale branch",
  },
  [PlanetscaleErrorType.BRANCH_DELETION_FAILED]: {
    sentryDescription: "PlanetScale branch deletion returned an unexpected status",
  },
  [PlanetscaleErrorType.STALE_BRANCH_CLEANUP_CIRCUIT_BREAKER]: {
    sentryDescription: "Stale PlanetScale branch cleanup exceeded its max-deletions circuit breaker",
  },
  [PlanetscaleErrorType.PLANET_SCALE_CLEANUP_TOKEN_MISSING]: {
    sentryDescription: "PlanetScale cleanup service token environment variables are missing",
  },
};
